import React from "react";
import { Link } from "react-router-dom";
import TopicOne from "../../../components/market-contents/forex-market-contents/TopicOne";

const ForexMarketContentOne = () => {
  return (
    <>
      {/* Add the TopicOne component here */}
      <TopicOne />

      <div className="how__work__market">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
              <div className="content-left">
                <h3>Ultra-Low & Stable Spreads</h3>
                <p>
                  Execute trades with industry-leading spreads designed to
                  optimize every pip of your strategy.
                </p>
                <h3>Institutional-Grade Liquidity</h3>
                <p>
                  Benefit from deep liquidity across major, minor, and exotic
                  pairs, ensuring consistent execution, even in volatile markets
                </p>
                <h3>Advanced Trading Infrastructure</h3>
                <p>
                  Experience lightning-fast order execution powered by
                  cutting-edge technology and the trusted MetaTrader 5 platform.
                </p>
                <h3>Transparent, Trader-First Conditions</h3>
                <p>
                  No hidden fees, no requotes, just fair pricing and full
                  visibility across every trade.
                </p>
                {/* <Link
                  className="slide__btn dg__btn"
                  to={process.env.PUBLIC_URL + "/company/contact"}
                >
                  Register now
                </Link> */}
              </div>
            </div>
            <div className="col-lg-6 col-md-12 col-sm-12 col-12 sm__mt--40 md__mt--40">
              <div className="thumb-right">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/markets/forex_cfd/forex_1.png"
                  }
                  alt="computer images"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForexMarketContentOne;
